import { SegmentTypes } from 'features/segment-controls/constants/segment-types';
import { Segment } from '../segment-controls.types';
import { v4 as guid } from 'uuid';

export function createSegment(importance: number): Segment {
  return {
    id: guid(),
    order: importance,
    segmentType: SegmentTypes.CUSTOM_DATA_KEY, // Temporary - this needs changing when we add more than CustomDataKey,
    segmentCategory: ''
  };
}
